import React, { Component } from "react";
import { Slider } from "materialize-css";
import MeteDecorator from "../../services/MetaDecorator";
import ourServices from "../../../media/images/ourServices.jpg";
import sharepointOnline from "../../../media/images/sharepointOnline.jpg";
import msPowerPlatform from "../../../media/images/msPowerPlatform.jpg";
import msTeams from "../../../media/images/msTeams.jpg";
import msAzure from "../../../media/images/msAzure.jpg";
import websites from "../../../media/images/websites.jpg";
import softwareDevelopment from "../../../media/images/softwareDevelopment.jpg";
import innovation from "../../../media/images/innovation.jpg";
import convincing from "../../../media/images/convincing.jpg";
import quality from "../../../media/images/quality.jpg";

export default class Startsite extends Component {
  constructor(props) {
    super(props);
    this.sliderRef = React.createRef();
    this.state = {
      width: window.innerWidth,
    };
  }

  componentDidMount() {
    let tabs = document
      .getElementsByClassName("nav-wrapper")[1]
      .querySelectorAll("ul")[0]
      .querySelectorAll("a");
    for (let i = 0; i < tabs.length; i++) {
      tabs[i].removeAttribute("class");

      if (tabs[i].id === "startsite") {
        tabs[i].setAttribute("class", "orange-text text-darken-4");
      }
    }

    let mobileTabs = document
      .getElementsByClassName("sidenav")[0]
      .querySelectorAll("a");
    for (let i = 0; i < mobileTabs.length; i++) {
      if (mobileTabs[i].id === "startsiteMobile") {
        mobileTabs[i].removeAttribute("class");
        mobileTabs[i].setAttribute(
          "class",
          "orange-text text-darken-4 grey darken-3"
        );
      }
    }

    // var elems = document.querySelectorAll('.slider');
    Slider.init(this.sliderRef.current);

    this.updateWindowDimensions();
    window.addEventListener("resize", this.updateWindowDimensions.bind(this));
  }

  updateWindowDimensions = () => {
    this.setState({ width: window.innerWidth });
  };

  render() {
    const { width } = this.state;
    const isMobile = width <= 600;
    const isTablet = width <= 992 && width > 600;
    return (
      <React.Fragment>
        <MeteDecorator
          url="https://www.jetminds.de"
          title="JetMinds | Moderne Informationstechnologien & digitale Transformation"
          descrption="Wir gestalten die digitale Transformation in Unternehmen mit dem Ziel digitale Arbeitsplätze zu schaffen und die routinemäßigen Aktivitäten auf ein Minimum zu reduzieren"
        />
        <div
          className={`${!isMobile && !isTablet ? "siteSlider " : ""}slider`}
          ref={this.sliderRef}
        >
          <ul
            className={`${!isMobile && !isTablet ? "siteSlides " : ""}slides`}
          >
            <li>
              <img
                src={ourServices}
                alt="JetMinds Unsere Dienstleistungen"
                loading="lazy"
              />
              <div
                className={`${
                  isMobile || isTablet ? "moduleMobile" : "module"
                } caption left-align`}
              >
                {isMobile || isTablet ? (
                  <h5 className="center">Unsere Dienstleistungen</h5>
                ) : (
                  <h4 className="center">Unsere Dienstleistungen</h4>
                )}
                <h6 className="text-lighten-3 center">
                  Leistungsstarker Einsatz digitaler Technologien für die
                  Zusammenarbeit, Softwareentwicklung und Webseiten
                </h6>
                <div className="center">
                  {isMobile || isTablet ? (
                    <a
                      href="/fokusbereiche"
                      className="btn-large orange darken-4"
                      style={{ marginTop: "20px", marginRight: "-13px" }}
                    >
                      Mehr erfahren
                    </a>
                  ) : (
                    <a
                      href="/fokusbereiche"
                      className="btn-large orange darken-4"
                      style={{ margin: "20px" }}
                    >
                      Mehr erfahren
                    </a>
                  )}
                </div>
              </div>
            </li>
            <li>
              <img
                src={sharepointOnline}
                alt="JetMinds SharePoint Online"
                loading="lazy"
              />
              <div
                className={`${
                  isMobile || isTablet ? "moduleMobile" : "module"
                } caption right-align`}
              >
                {isMobile || isTablet ? (
                  <h5 className="center">SharePoint Online</h5>
                ) : (
                  <h4 className="center">SharePoint Online</h4>
                )}
                <h6 className="text-lighten-3 center">
                  Beratung, Integration, Support und Wartung, Administration,
                  Migration und maßgeschneiderte Lösungen auf Basis von
                  SharePoint Online
                </h6>
                <div className="center">
                  {isMobile || isTablet ? (
                    <a
                      href="/fokusbereiche/sharepoint-online"
                      className="btn-large orange darken-4"
                      style={{ marginTop: "20px", marginLeft: "-13px" }}
                    >
                      Weitere Details
                    </a>
                  ) : (
                    <a
                      href="/fokusbereiche/sharepoint-online"
                      className="btn-large orange darken-4"
                      style={{ margin: "20px" }}
                    >
                      Weitere Details
                    </a>
                  )}
                </div>
              </div>
            </li>
            <li>
              <img
                src={msPowerPlatform}
                alt="JetMinds Microsoft Power Platform"
                loading="lazy"
              />
              <div
                className={`${
                  isMobile || isTablet ? "moduleMobile" : "module"
                } caption right-align`}
              >
                {isMobile || isTablet ? (
                  <h5 className="center">Power Platform</h5>
                ) : (
                  <h4 className="center">Power Platform</h4>
                )}
                <h6 className="text-lighten-3 center">
                  Effektive Lösungen für automatisierte Workflows, hochwertige
                  Datenanalyse, intelligente Geschäftsanwendungen und moderne
                  Chatbots
                </h6>
                <div className="center">
                  {isMobile || isTablet ? (
                    <a
                      href="/fokusbereiche/power-platform"
                      className="btn-large orange darken-4"
                      style={{ marginTop: "20px", marginRight: "-13px" }}
                    >
                      Mehr Infos
                    </a>
                  ) : (
                    <a
                      href="/fokusbereiche/power-platform "
                      className="btn-large orange darken-4"
                      style={{ margin: "20px" }}
                    >
                      Jetzt entdecken
                    </a>
                  )}
                </div>
              </div>
            </li>
            <li>
              <img
                src={msTeams}
                alt="JetMinds Microsoft Teams"
                loading="lazy"
              />
              <div
                className={`${
                  isMobile || isTablet ? "moduleMobile" : "module"
                } caption left-align`}
              >
                {isMobile || isTablet ? (
                  <h5 className="center">Microsoft Teams</h5>
                ) : (
                  <h4 className="center">Microsoft Teams</h4>
                )}
                <h6 className="text-lighten-3 center">
                  Das leistungsstärkste Tool für die Zusammenarbeit,
                  ortsunabhängig kommunizieren und nahtlos im Team arbeiten
                </h6>
                <div className="center">
                  {isMobile || isTablet ? (
                    <a
                      href="/fokusbereiche/microsoft-teams"
                      className="btn-large orange darken-4"
                    >
                      zu den Details
                    </a>
                  ) : (
                    <a
                      href="/fokusbereiche/microsoft-teams"
                      className="btn-large orange darken-4"
                      style={{ margin: "20px" }}
                    >
                      Mehr Information
                    </a>
                  )}
                </div>
              </div>
            </li>
            <li>
              <img
                src={msAzure}
                alt="JetMinds Microsoft Azure"
                loading="lazy"
              />
              <div
                className={`${
                  isMobile || isTablet ? "moduleMobile" : "module"
                } caption left-align`}
              >
                {isMobile || isTablet ? (
                  <h5 className="center">Microsoft Azure</h5>
                ) : (
                  <h4 className="center">Microsoft Azure</h4>
                )}
                <h6 className="text-lighten-3 center">
                  wandelt Ideen mit vertrauenswürdigen Produkten und Diensten in
                  innovative Lösungen um
                </h6>
                <div className="center">
                  {isMobile || isTablet ? (
                    <a
                      href="/fokusbereiche/microsoft-azure"
                      className="btn-large orange darken-4"
                      style={{ marginTop: "20px", marginLeft: "-13px" }}
                    >
                      Information
                    </a>
                  ) : (
                    <a
                      href="/fokusbereiche/microsoft-azure"
                      className="btn-large orange darken-4"
                      style={{ margin: "20px" }}
                    >
                      Detaillierte Angaben
                    </a>
                  )}
                </div>
              </div>
            </li>
            <li>
              <img
                src={softwareDevelopment}
                alt="JetMinds Softwareentwicklung"
                loading="lazy"
              />
              <div
                className={`${
                  isMobile || isTablet ? "moduleMobile" : "module"
                } caption right-align`}
              >
                {isMobile || isTablet ? (
                  <h5 className="center">Software Development</h5>
                ) : (
                  <h4 className="center">Software Development</h4>
                )}
                <h6 className="text-lighten-3 center">
                  Softwareentwicklung und Softwareberatung für komplexe
                  Geschäftslösungen basierend auf Microsoft 365
                </h6>
                <div className="center">
                  {isMobile || isTablet ? (
                    <a
                      href="/fokusbereiche/softwareentwicklung"
                      className="btn-large orange darken-4"
                      style={{ marginTop: "20px", marginRight: "-13px" }}
                    >
                      Weitere aspekte
                    </a>
                  ) : (
                    <a
                      href="/fokusbereiche/softwareentwicklung"
                      className="btn-large orange darken-4"
                      style={{ margin: "20px" }}
                    >
                      Weitere aspekte
                    </a>
                  )}
                </div>
              </div>
            </li>
            <li>
              <img src={websites} alt="JetMinds Webseiten" loading="lazy" />
              <div
                className={`${
                  isMobile || isTablet ? "moduleMobile" : "module"
                } caption left-align`}
              >
                {isMobile || isTablet ? (
                  <h5 className="center">Webseiten</h5>
                ) : (
                  <h4 className="center">Webseiten</h4>
                )}
                <h6 className="text-lighten-3 center">
                  Sehr moderne und responsive Webseiten für Ihr Unternehmen, die
                  Ihre Präsenz sehr professionell darstellen
                </h6>
                <div className="center">
                  {isMobile || isTablet ? (
                    <a
                      href="/fokusbereiche/webseiten"
                      className="btn-large orange darken-4"
                    >
                      Nähere Vorteile
                    </a>
                  ) : (
                    <a
                      href="/fokusbereiche/webseiten"
                      className="btn-large orange darken-4"
                      style={{ margin: "20px" }}
                    >
                      Mehr Vorteile
                    </a>
                  )}
                </div>
              </div>
            </li>
          </ul>
        </div>
        <div className="container">
          <div className="section">
            <div className="row">
              <div className="col s12 m12 right">
                <h1
                  className={`${
                    isMobile ? "startTitleM" : "startTitle"
                  } center`}
                >
                  Dienstleister für moderne Informationstechnologien und
                  digitale Transformation
                </h1>
                <p className="light">
                  Jeder Tag zeigt sehr deutlich, wie wichtig die digitale
                  Transformation in allen beruflichen sowie privaten Bereichen
                  ist. Leidenschaftlich und mit fester Überzeugung sind wir
                  Vertreter des digitalen Arbeitsplatzes, der Unternehmen
                  Dienstleistungen in fünf Hauptdimensionen anbietet: Beratung
                  und Konzeption, Kommunikation und Kollaboration,
                  Dokumentenmanagement und Mobilität, Smart Business
                  Applications und automatisierte Geschäftsprozesse sowie
                  serverless Compute und End-to-End Development. Wir gestalten
                  die digitale Transformation in Unternehmen mit dem Ziel
                  digitale Arbeitsplätze zu schaffen und die routinemäßigen
                  Aktivitäten auf ein Minimum zu reduzieren. Dadurch bekommen
                  die Mitarbeiterinnen und Mitarbeiter Zeit und Raum für
                  Kreativität und somit zu mehr Produktivität. Darüber hinaus
                  bieten wir Schulungen, Software- und Webseitenentwicklungen
                  an.
                </p>
              </div>
            </div>
            <div className="row">
              <div className={`col s12 ${isTablet ? "m12" : "m4"}`}>
                <div className="icon-block">
                  <h2 className="center orange-text text-darken-4">
                    <i className="material-icons" style={{ fontSize: "35px" }}>
                      developer_board
                    </i>
                  </h2>
                  <h5 className="center">Beratung und Konzeption</h5>
                  <p className="light">
                    Wir stehen Ihnen mit fundierter technischer sowie
                    funktioneller Beratung rund um das Thema moderne
                    Informationstechnologien und digitale Transformation,
                    insbesondere{" "}
                    <a
                      className="orange-text text-darken-4"
                      href="/fokusbereiche/sharepoint-online"
                    >
                      SharePoint Online
                    </a>
                    ,{" "}
                    <a
                      className="orange-text text-darken-4"
                      href="/fokusbereiche/power-platform"
                    >
                      Power Platform
                    </a>
                    ,{" "}
                    <a
                      className="orange-text text-darken-4"
                      href="/fokusbereiche/microsoft-teams"
                    >
                      Microsoft Teams
                    </a>{" "}
                    und{" "}
                    <a
                      className="orange-text text-darken-4"
                      href="/fokusbereiche/microsoft-azure"
                    >
                      Azure
                    </a>{" "}
                    zur Seite. Profitieren Sie von unseren Erfahrungen aus
                    vielen Projekten, die Ihnen den Einstieg in die digitale
                    Transformation erleichtern.
                  </p>
                </div>
              </div>
              <div className={`col s12 ${isTablet ? "m12" : "m4"}`}>
                <div className="icon-block">
                  <h2 className="center orange-text text-darken-4">
                    <i className="material-icons" style={{ fontSize: "35px" }}>
                      chrome_reader_mode
                    </i>
                  </h2>
                  <h5 className="center">Kommunikation und Kollaboration</h5>
                  <p className="light">
                    Ihre Wünsche, unsere fachlichen Empfehlungen und Erfahrungen
                    sowie die modernen Technologien sind die Roadmap für die
                    perfekte Kommunikation- und Kollaborationsplattform, die
                    Ihren Bedürfnissen und Erwartungen entspricht. Erleben Sie
                    die digitale Zukunft und arbeiten gemeinsam ortsunabhängig.
                  </p>
                </div>
              </div>
              <div className={`col s12 ${isTablet ? "m12" : "m4"}`}>
                <div className="icon-block">
                  <h2 className="center orange-text text-darken-4">
                    <i className="material-icons" style={{ fontSize: "35px" }}>
                      library_add
                    </i>
                  </h2>
                  <h5 className="center">Dokumentenmanagement und Mobilität</h5>
                  <p className="light">
                    Im Bereich DMS haben digitale Funktionen eine sehr wichtige
                    Bedeutung für Unternehmen. Wir bieten Ihnen: Struktur durch
                    Zuweisung von Meta-Daten, Sicherheit durch Vergabe von
                    Berechtigungsstufen, Kontrolle durch automatische
                    Versionierungen, Performance durch leistungsstarke
                    Volltextsuchfunktion und vieles mehr.
                  </p>
                </div>
              </div>
            </div>
            <div className="row">
              <div className={`col s12 ${isTablet ? "m12" : "m4"}`}>
                <div className="icon-block">
                  <h2 className="center orange-text text-darken-4">
                    <i className="material-icons" style={{ fontSize: "35px" }}>
                      apps
                    </i>
                  </h2>
                  <h5 className="center">
                    Smart Business Applications und Workflows
                  </h5>
                  <p className="light">
                    Wir unterstützen Ihr Unternehmen beim sofortigen Aufbau und
                    Launching von Smart Business Appications und Add-Ins mit den
                    leistungsstärksten Technologien von Microsoft wie SharePoint
                    Online, Power Platform und Azure, die die Datenintegration
                    und -verteilung ermöglichen und Ihre Unternehmensplattform
                    mit zahlreichen automatisierten Workflows erweitern.
                  </p>
                </div>
              </div>
              <div className={`col s12 ${isTablet ? "m12" : "m4"}`}>
                <div className="icon-block">
                  <h2 className="center orange-text text-darken-4">
                    <i className="material-icons" style={{ fontSize: "35px" }}>
                      all_inclusive
                    </i>
                  </h2>
                  <h5 className="center">
                    Serverless Compute und End-to-End Development
                  </h5>
                  <p className="light">
                    Wir bieten Ihnen eine vollständige End-to-End-Entwicklung
                    von der Erstellung bis zur Bereitstellung und Überwachung in
                    der Cloud. Die Vorteile dieser serverless Lösungen sind u.
                    a. die automatisierte und flexible Skalierung basierend auf
                    Ihrem Workload-Volumen, wobei der Fokus auf der
                    Wertschöpfung liegt, anstatt die Infrastruktur zu verwalten.
                  </p>
                </div>
              </div>
              <div className={`col s12 ${isTablet ? "m12" : "m4"}`}>
                <div className="icon-block">
                  <h2 className="center orange-text text-darken-4">
                    <i className="material-icons" style={{ fontSize: "35px" }}>
                      code
                    </i>
                  </h2>
                  <h5 className="center">Softwareentwicklung und Webseiten</h5>
                  <p className="light">
                    Innovative, maßgefertigte{" "}
                    <a
                      className="orange-text text-darken-4"
                      href="/fokusbereiche/softwareentwicklung"
                    >
                      Software- und Weblösungen
                    </a>{" "}
                    auf Basis von Microsoft SharePoint Online, Azure und Teams
                    für Ihre speziellen Anforderungen. Außerdem bieten wir Ihnen
                    sehr moderne und responsive{" "}
                    <a
                      className="orange-text text-darken-4"
                      href="/fokusbereiche/webseiten"
                    >
                      Webseiten
                    </a>{" "}
                    für Ihr Unternehmen, die Ihre Präsenz sehr professionell und
                    benutzerfreundlich darstellen.
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div className="section">
            <div className="row">
              <div className={`col s12 ${isTablet ? "m12" : "m4"}`}>
                <div className="card">
                  <div className="card-image">
                    <img
                      className="activator"
                      src={innovation}
                      alt="JetMinds Innovation"
                      loading="lazy"
                    />
                  </div>
                  <div className="card-content">
                    <span className="card-title activator grey-text text-darken-4">
                      Innovation
                      <i className="material-icons right">more_vert</i>
                    </span>
                    <p className="orange-text text-darken-4">„Keine Grenzen“</p>
                  </div>
                  <div className="card-reveal">
                    <span className="card-title grey-text text-darken-4">
                      Innovation<i className="material-icons right">close</i>
                    </span>
                    <p className="light">
                      Ihre Herausforderungen inspirieren uns zu neuen, kreativen
                      und brillanten Ideen, die zu Ihrem Unternehmenserfolg
                      beitragen.
                    </p>
                  </div>
                </div>
              </div>
              <div className={`col s12 ${isTablet ? "m12" : "m4"}`}>
                <div className="card">
                  <div className="card-image">
                    <img
                      className="activator"
                      src={convincing}
                      alt="JetMinds Überzeugend"
                      loading="lazy"
                    />
                  </div>
                  <div className="card-content">
                    <span className="card-title activator grey-text text-darken-4">
                      Überzeugend
                      <i className="material-icons right">more_vert</i>
                    </span>
                    <p className="orange-text text-darken-4">
                      „Lassen Sie sich beraten“
                    </p>
                  </div>
                  <div className="card-reveal">
                    <span className="card-title grey-text text-darken-4">
                      Überzeugend<i className="material-icons right">close</i>
                    </span>
                    <p className="light">
                      Durch Transparenz und Offenheit sowie solide fachliche
                      Kompetenz und Zuverlässigkeit gewinnen wir Sie als
                      zufriedenen Kunden.
                    </p>
                  </div>
                </div>
              </div>
              <div className={`col s12 ${isTablet ? "m12" : "m4"}`}>
                <div className="card">
                  <div className="card-image">
                    <img
                      className="activator"
                      src={quality}
                      alt="JetMinds Qualität"
                      loading="lazy"
                    />
                  </div>
                  <div className="card-content">
                    <span className="card-title activator grey-text text-darken-4">
                      Qualität<i className="material-icons right">more_vert</i>
                    </span>
                    <p className="orange-text text-darken-4">
                      „Garantiert bemerkenswert“
                    </p>
                  </div>
                  <div className="card-reveal">
                    <span className="card-title grey-text text-darken-4">
                      Qualität<i className="material-icons right">close</i>
                    </span>
                    <p className="light">
                      Unsere mehrjährige Expertise und kontinuierliches Update
                      des neuesten Stands der Technik garantieren unsere
                      hochwertige Arbeit.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="center section grey lighten-2">
          <div className="row">
            <div className="col s12 m12">
              <br />
              <span
                className="orange-text text-darken-4"
                style={{ fontSize: "60px" }}
              >
                ❝
              </span>
              <br />
              <h5 className="wisdom">
                Wenn der Wind der Veränderung weht, bauen die einen Mauern und
                die anderen Windmühlen
              </h5>
              <br />
              <span
                className="orange-text text-darken-4"
                style={{ fontSize: "12px" }}
              >
                Altes chinesisches Sprichwort
              </span>
              <br />
            </div>
          </div>
        </div>
        <div></div>
      </React.Fragment>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/layout/pages/Startsite.js